export default __webpack_public_path__ + "static/media/640_dummy2016-kunstshop01-mobile-de.4812150b.png";